var map = {
	"./human-resources-admin-inspection-detail-icon.png": "60f6",
	"./human-resources-cost-payment-detail-icon.png": "5bf9",
	"./human-resources-dorm-inspection-detail-icon.png": "98d7",
	"./human-resources-employee-training-detail-icon.png": "b10a",
	"./human-resources-invite-job-detail-icon.png": "5516",
	"./human-resources-pay-submit-detail-icon.png": "7a2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e03";